var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DtHeader'),_c('el-container',{staticClass:"content"},[_c('DtMenu'),_c('el-container',[_c('el-main',[_c('DtBreadcrumb'),_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }